import AbstractTagModel from './AbstractTagModel';
import doc              from '@widesk-core/decorators/doc';
import { getLocale }    from '@widesk-core/locale';
import { Translatable } from '@widesk-core/decorators/translatable';
import CustomTag        from '@/components/CustomTag';

@doc.urnResource('tag')
@doc.translatable({ description: true, label: true })
class TagModel extends AbstractTagModel {
	public get description() {
		return this.translation('description', getLocale());
	}

	public get customTag() {
		return CustomTag;
	}
}

interface TagModel
	extends Translatable<{ description: true, label: true }> {
}

export default TagModel;
